export const eventEmitter = () => {
  const events = new Map()
  const oneEvents = new Map()
  const setEvents = new Map()
  const on = (event, listener) => {
    events.has(event)
      ? events.get(event).push(listener)
      : events.set(event, [listener])
  }

  const emit = (event, ...args) => {
    if (events.has(event)) {
      events.get(event).forEach(listener => {
        if (listener instanceof Function) {
          listener.apply(this, args)
        }
      })
    }
    if (oneEvents.has(event)) {
      oneEvents.get(event).forEach(listener => {
        if (listener instanceof Function) {
          listener.apply(this, args)
        }
      })
      oneEvents.delete(event)
    }
    if (setEvents.has(event)) {
      setEvents.get(event).apply(this, args)
    }
  }
  /* once the event got emitted the event listener will be clear */
  const one = (event, listener) => {
    oneEvents.has(event)
      ? oneEvents.get(event).push(listener)
      : oneEvents.set(event, [listener])
  }
  /* will cover any  event listener of the same name to prevent listen and trigger mulitiple times  */
  const set = (event, listener) => {
    setEvents.set(event, listener)
  }

  return {
    events,
    on,
    emit,
    one,
    set
  }
}

export const subscribeEvents = (eventListeners) => {
  return (target, enabledEvents, emitter) => {
    const eventList = []
    enabledEvents.forEach(eventName => {
      target.on(eventName, eventListeners[eventName].bind({ target, events: emitter }))
      eventList.push(eventName)
    })
    console.table(eventList)
  }
}
